'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var castArray = require('lodash/castArray');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var castArray__default = /*#__PURE__*/_interopDefaultLegacy(castArray);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

class FullTextSearch {
    constructor(app, className) {
        this.app = app;
        this._clazz = className;
    }
    get params() {
        var _a, _b, _c, _d, _e;
        if (!this._q) {
            throw new Error('执行全文搜索时必须提供 queryString');
        }
        const params = {
            q: this._q,
            clazz: this._clazz,
            skip: this._skip,
            limit: this._limit,
            sid: this._sid,
        };
        if ((_a = this._fields) === null || _a === void 0 ? void 0 : _a.length) {
            params.fields = this._fields.join(',');
        }
        if ((_b = this._highlights) === null || _b === void 0 ? void 0 : _b.length) {
            params.highlights = this._highlights.join(',');
        }
        if ((_c = this._include) === null || _c === void 0 ? void 0 : _c.length) {
            params.include = this._include.join(',');
        }
        if ((_d = this._order) === null || _d === void 0 ? void 0 : _d.size) {
            params.order = Array.from(this._order).join(',');
        }
        if ((_e = this._sort) === null || _e === void 0 ? void 0 : _e.length) {
            params.sort = this._sort;
        }
        return params;
    }
    queryString(str) {
        this._q = str;
        return this;
    }
    skip(count) {
        this._skip = count;
        return this;
    }
    limit(count) {
        this._limit = count;
        return this;
    }
    sid(sid) {
        this._sid = sid;
        return this;
    }
    fields(fields, ...rest) {
        this._fields = castArray__default["default"](fields).concat(rest);
        return this;
    }
    include(keys, ...rest) {
        this._include = castArray__default["default"](keys).concat(rest);
        return this;
    }
    highlights(keys, ...rest) {
        this._highlights = castArray__default["default"](keys).concat(rest);
        return this;
    }
    orderBy(key, order) {
        if (!order || typeof order === 'string') {
            return this._orderBy(key, order);
        }
        else {
            return this._sortBy(key, order);
        }
    }
    whereNear(key, geo, options) {
        if (!this._sort) {
            this._sort = [];
        }
        this._sort.push({
            _geo_distance: Object.assign(Object.assign({}, options), { [key]: [geo.latitude, geo.longitude] }),
        });
        return this;
    }
    find(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const rawResult = yield this.app.request({
                method: 'GET',
                path: '/1.1/search/select',
                query: this.params,
            }, options);
            return new FullTextSearchResult(this.app, rawResult);
        });
    }
    _orderBy(key, order = 'asc') {
        if (!this._order) {
            this._order = new Set();
        }
        switch (order) {
            case 'asc':
                this._order.add(key).delete('-' + key);
                break;
            case 'desc':
                this._order.add('-' + key).delete(key);
                break;
            default:
                throw new TypeError(`未知的查询排序方式 ${order}`);
        }
        return this;
    }
    _sortBy(key, options) {
        if (!this._sort) {
            this._sort = [];
        }
        this._sort.push({ [key]: options });
        return this;
    }
}
class FullTextSearchResult {
    constructor(_app, rawResult) {
        this._app = _app;
        this.hits = 0;
        this.data = [];
        this._setRawResult(rawResult);
    }
    _setRawResult(rawResult) {
        this.sid = rawResult.sid;
        if (rawResult.hits) {
            this.hits = rawResult.hits;
        }
        if (rawResult.results) {
            const db = this._app.database();
            this.data = rawResult.results.map((result) => db.decodeObject(result));
        }
    }
    next(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.data.length === 0) {
                return this;
            }
            this._setRawResult(yield this._app.request({
                method: 'GET',
                path: '/1.1/search/select',
                query: { sid: this.sid },
            }, options));
            return this;
        });
    }
}

const searchModule = {
    name: 'search',
    components: { Search: FullTextSearch },
    onLoad: ({ modules }) => {
        const { Database } = modules.core.components;
        Database.prototype.search = function (className) {
            return new FullTextSearch(this.app, className);
        };
    },
};

exports.FullTextSearch = FullTextSearch;
exports.FullTextSearchResult = FullTextSearchResult;
exports.searchModule = searchModule;
